module.exports = __webpack_public_path__ + "img/fb-badge.7a4add81.png";